export default __webpack_public_path__ + "static/media/logo4.d836f21f.png";